import { useContext } from 'react';
import { MediaQueriesContext } from '@web/react-contexts';
/**
 * Returns MediaQueriesContext value with the MediaQueryState shape
 *
 * Example usage:
 * ```
 *  import { useMediaQueries } from '@web/react-hooks';
 *
 *  function Component(props: Props) {
 *    const { screenLg } = useMediaQueries();
 *
 *    return screenLg ? < logic for large screens > : < logic for smaller screens >;
 *  }
 * ```
 */
export default function useMediaQueries() {
    return useContext(MediaQueriesContext);
}
